import { useMutation } from '@tanstack/react-query';

import { AuthApi } from '@/api/domains/auth.api';
import { useGlobalErrorStore } from '@/components/dialogs/GlobalErrorDialog';

export const useVerifyToken = () => {
  const { setGlobalError } = useGlobalErrorStore();

  return useMutation({
    mutationFn: AuthApi.signUpVerifyToken,
    onError: setGlobalError,
  });
};
